import { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";

const BROWSER_SESSION_ID_KEY = "supabanner-browser-session-id";

export function getBrowserSessionId() {
  return sessionStorage.getItem(BROWSER_SESSION_ID_KEY) || undefined;
}

export function EnsureBrowserSessionIdProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [browserSessionId, setBrowserSessionId] = useState<string | undefined>(
    getBrowserSessionId()
  );

  useEffect(() => {
    if (browserSessionId) return;

    const id = uuidv4();

    sessionStorage.setItem(BROWSER_SESSION_ID_KEY, id);
    setBrowserSessionId(id);
  }, [browserSessionId]);

  if (!browserSessionId) return null;

  return <>{children}</>;
}
